import script from "./newRefund.vue?vue&type=script&setup=true&lang=js"
export * from "./newRefund.vue?vue&type=script&setup=true&lang=js"

import "./newRefund.vue?vue&type=style&index=0&id=0071b47e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0071b47e"]])

export default __exports__